import type { ParsedUrlQuery } from 'node:querystring';
import { useEffect } from 'react';
import { setInitialBannerFilterValues } from 'shared/util/bannerParams';
import { queryParamToString } from 'shared/util/query';
import type { AutocompleteData, Filters } from '@/domain';

export const useInitialBannerFilters = (filters: Filters, autocompleteData?: AutocompleteData, query?: ParsedUrlQuery) => {
    useEffect(() => {
        setInitialBannerFilterValues({
            pageType: 'result',
            page: filters.page ?? undefined,
            destination: {
                city: autocompleteData?.trackingInfo?.city || filters.city || queryParamToString(query?.city) || undefined,
                country: autocompleteData?.trackingInfo?.country || filters.country || queryParamToString(query?.country) || undefined,
            },
        });
    }, []);
};
